import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import {GroupingOptionItem} from './grouping-options';

@Component({
    selector: 'grouping-selector',
    template: require('./grouping-selector.component.html'),
    styles: [require('./grouping-selector.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupingSelectorComponent {

    @Output()
    public selectedOptionChange = new EventEmitter<GroupingOptionItem>();

    @Input()
    public options: GroupingOptionItem[] = [];

    @Input()
    public groupName = 'mdl-group';

    @Input()
    public set selectedOption(value: GroupingOptionItem) {
        this.selectedOptionValue = value;
    }

    public get selectedOption() {
        return this.selectedOptionValue;
    }

    private selectedOptionValue: GroupingOptionItem;

    public optionTextGetter  = (option: any) => `Group by ${option.title || option.columnTitle}`;

    public optionValueGetter  = (option: any) => option.columnTitle;

    public onSelection(option: GroupingOptionItem) {
        this.selectedOptionChange.emit(option);
    }
}